module.exports = __webpack_public_path__ + "img/edit.0260530e.svg";